import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2.25, 3),
  },
  iconBox: {
    width: 44,
    height: 44,
    flex: 'none',
    borderRadius: 10,
    display: 'grid',
    placeItems: 'center',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
  },
  title: {
    flex: '1 1 auto',
    fontSize: 19,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  chips: {
    display: 'flex',
  },
  expand: {
    flex: 'none',
    width: 34,
    height: 34,
    color: theme.palette.secondary.main,
    transition: 'transform 220ms ease',
  },
  expandOpen: {
    transform: 'rotate(0deg)',
  },
  expandClosed: {
    transform: 'rotate(180deg)',
  },
  expandHidden: {
    visibility: 'hidden',
    pointerEvents: 'none',
  },
}))

export default useStyles
